/** ObservabilitySection — link to Langfuse dashboard. */

import { useEffect, useState } from 'react';
import { Button } from '@/shared/ui/button';

interface ObservabilityConfig {
  langfuse: {
    configured: boolean;
    dashboard_url: string | null;
    base_url: string | null;
    project_id: string | null;
    filter_instructions: Record<string, string>;
  };
}

export default function ObservabilitySection() {
  const [observability, setObservability] = useState<ObservabilityConfig | null>(null);

  useEffect(() => {
    const fetchObservability = async () => {
      try {
        // No Authorization header — session cookie sent automatically via credentials: 'include'.
        const resp = await fetch('/api/v1/admin/observability', {
          credentials: 'include',
        });
        if (resp.ok) {
          const data = (await resp.json()) as ObservabilityConfig;
          setObservability(data);
        }
      } catch {
        // Non-critical
      }
    };
    fetchObservability();
  }, []);

  if (!observability?.langfuse?.dashboard_url) return null;

  return (
    <section className="mt-6 flex flex-col gap-2">
      <h3 className="text-sm font-semibold text-foreground">Observability</h3>
      <p className="text-xs text-muted-foreground">Usage analytics and tracing.</p>

      <div className="mt-3 flex flex-wrap items-center gap-2">
        <a
          href={observability.langfuse.dashboard_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button variant="secondary">Open Langfuse Dashboard</Button>
        </a>
      </div>
    </section>
  );
}
